import "./Loader.css";
import React from "react";

const Loader = () => {
  return (
    <div className="lds-container">
      <div className="lds-ripple">
        <div />
        <div />
      </div>
      <p>Loading...</p>
    </div>
  );
};

Loader.displayName = 'Loader';

export default React.memo(Loader);
